import React, { Fragment, useState } from 'react';

import { useTranslation } from 'react-i18next/hooks';


import Backdrop from '../../../Backdrop/Backdrop';
import Button from '../../../Button/Button';
import FilesUploadAction from '../../../FileUploadAction/FilesUploadAction';
import Img from "react-cool-img";
import SmallModal from '../../../Modal/SmallModal';

import { isImageFile, isVideoFile, isAudioFile } from '../../../../util/image';
import { SOCKET_GROUP_URL } from '../../../../App';

import { marks } from '../../../../images/marks';
import classes from './GroupTalkTextFile.module.css';
// import './VideoTextTalk.css'




const GroupTalkTextFile = (props) => {
  // console.log('VideoTextTalkTextFile.js props', props);
  const {
    // textInputList,
    inputData,
    // userId,
    // destUser,
    // noconnectTextDeleteHandler,
    // isLoading,
  } = props;
  

  const [t] = useTranslation('translation');

  const [showSepImage, setShowSepImage] = useState(false);

  // const [showFileUpload, setShowFileUpload] = useState(false);
  
  const setShowSepImageHandler = (value) => {
    if (!inputData.kuraFileInfo?.key) {
      setShowSepImage(value);
    }
  };

  // const showFileUploadHandler = () => {
  //   setShowFileUpload(true);
  // };

  // const pictureInPictureHandler = () => {
  //   const videoEl = document.getElementById('video');
    
  //   videoEl.requestPictureInPicture();
  // };

  
  let fileImageBody;

  if (inputData && inputData.fileUrls && inputData.fileUrls.length > 0) {

    // let fileImageUrl = inputData.fileUrls[0];
    let fileImageUrl = SOCKET_GROUP_URL + '/' + inputData.fileUrls[0];
    let sFileImageUrl = SOCKET_GROUP_URL + '/' + inputData.fileUrls[0];

    if (inputData.fileUrls[0].startsWith('https')) {
      const beforeQueryList = inputData.fileUrls[0].split('?');
      beforeQueryList.pop();

      sFileImageUrl = beforeQueryList.join('?');
      fileImageUrl = inputData.fileUrls[0];
    }
    
    // const fileNameList = fileImageUrl.split('.');
    // const fileExt = fileNameList.pop();
    const fileNameList = sFileImageUrl.split('.');
    const fileExt = fileNameList.pop();




    if (isImageFile(fileExt)) {
      if (!showSepImage) {

        if (!inputData.fileUrls[0].startsWith('https')) {
          fileImageBody = (
            <div
              onClick={() => {
                setShowSepImageHandler(true);
              }}
            >
              <img className={classes.textTalkFileImage}
                // style={{ maxWidth: "200px"}} 
                // src={inputData.fileUrls[0]} 
                // src={null}
                src={fileImageUrl}
                alt="image file not found" 
              />
            </div>
          )
        } else {
          fileImageBody = (
            <div 
              onClick={() => {
                setShowSepImageHandler(true);
              }}
            >
              <Img className={classes.textTalkFileImage}
                // style={{ maxWidth: "200px"}} 
                // src={inputData.fileUrls[0]} 
                src={fileImageUrl}
                alt="image in text" 
              />
            </div>
          );
        }
      }

      if (showSepImage) {
        fileImageBody = (
          <div>
            <Backdrop 
              onClick={() => { 
                setShowSepImage(!showSepImage); 
              }}
            />
            <SmallModal style={classes.sepImageModal}>
              <div>
                <div className={classes.sepImageModalClose}>
                  <span className={classes.sepImageModalCloseButton}
                    onClick={() => { 
                      setShowSepImageHandler(false);
                    }}
                  >
                    X
                  </span>
                </div>
                <div className={classes.sepImageModalSection}>
                  <div className={classes.sepImageModalImageContainer}>
                    <Img 
                      className={classes.sepImageModalImage}
                      // src={inputData.fileUrls[0]} 
                      src={fileImageUrl}
                      alt="image in text" 
                    />
                  </div>
                </div>

                {/* <div className={classes.sepImageModalSection}>
                  <Button mode="raised" design="" type="submit" 
                      // className='btnBase'
                      // style={{ fontSize: "1.25rem", fontWeight: "bold", border: "1px solid gray" }}
                      // disabled={isLoading}
                      onClick={showFileUploadHandler}
                    >
                      Store File {marks.uploadMark}
                  </Button>
                </div> */}

                <div className={classes.sepImageModalSection}>
                  <FilesUploadAction 
                    filePaths={inputData.filePaths}
                    uploadApp={`groupTalk-${inputData.groupRoomId}`}
                    kuraFileInfo={inputData.kuraFileInfo}
                    groupRoomId={inputData.groupRoomId}
                  />
                </div>
              

              </div>
            </SmallModal>
          </div>
        )
      }
    }

    if (isVideoFile(fileExt)) {
      fileImageBody = (
        <div>
          <video className={classes.textTalkFileVideo}
            // style={{ maxWidth : "200px" }}
            // id="video"
            id={fileImageUrl}
            controls
            // muted 
            src={fileImageUrl}
            alt="video in text" 
          />
        </div>
      );
    }

    if (isAudioFile(fileExt)) {
      fileImageBody = (
        <audio className={classes.textTalkFile}
        // style={{maxWidth:"100%"}}
        // src={inputData.fileUrls[0]}
        controls
        src={fileImageUrl}
        alt="audio in text" 
        />
      );
    }

    if (!isImageFile(fileExt) && 
        !isVideoFile(fileExt) && 
        !isAudioFile(fileExt)
    ) {
      if (fileImageUrl) {
        const fileUrl = new URL(fileImageUrl);
        const fileName = fileUrl.pathname.split('/').pop();
        // console.log('fileName', fileName);
        const cridIndex = fileName.indexOf('crid');
        // console.log('cridIndex', cridIndex); 
        const originalName = fileName.slice(cridIndex + 5);
        
        fileImageBody = (
          <div className={classes.textTalkFile}>
            <div>
              {originalName}
            </div>
            {/* <div>
              <a style={{color: 'gray', textDecoration: "none" }}
                href={fileImageUrl} target="_blank" rel="noopener noreferrer">
                downlad-file
              </a>
            </div> */}
          </div>
        );
      }
      
    }

  }



  return (
    <Fragment>
      {/* {inputData.sendAt + 1000*6*1 < Date.now() && (
        <div>temp-file-deleted</div>
      )} */}
      {fileImageBody}
    </Fragment>
  );
};

export default GroupTalkTextFile;